export const environment = {
  production: true,
  authRequired: true,
  idleMinutes: 115,
  timeoutMinutes: 5,
  pingSeconds: 999999
};
